import { Container } from '@tencent/alloy-renderer';
import { ESourceType, GuideComponent } from '@src/slide/content-viewer/service/canvas-renderer/entry/base/feature/component/guide-component';
import { IGuidesManager } from '@src/slide/application/service/guides-manager/index.interface';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';

interface IEventElementProps {
    scale?: number;
}

/**
 * slide canvas空白/透明区域事件响应
 * 需要在画布没有元素的空白区域做事件响应时，可以挂在这
 */
export class TransparentEventElement extends Container {
    private masterGuideComponent: GuideComponent;
    private layoutGuideComponent: GuideComponent;
    private slideGuideComponent: GuideComponent;
    private guidesManager?: IGuidesManager;
    private scale: number;

    constructor(props: IEventElementProps) {
        super();
        this.guidesManager = this.getAppService().editableServiceLayer?.guidesManager;
        this.renderEventComponent();
    }

    public dispose() {
        super.dispose();
    }

    /**
     * 构建所有事件组件
     */
    public renderEventComponent = () => {
        if (this.getAppService().editableServiceLayer?.guidesManager) {
            this.renderGuideComponent();
        }
    };

    /**
     * 构建参考线组件
     */
    private renderGuideComponent = () => {
        if (!this.slideGuideComponent) {
            this.slideGuideComponent = new GuideComponent({
                type: ESourceType.slide,
                isUiComponent: false,
            });
            this.addChild(this.slideGuideComponent);
        } else {
            this.slideGuideComponent.renderGuides();
        }

        if (!this.masterGuideComponent) {
            this.masterGuideComponent = new GuideComponent({
                type: ESourceType.master,
                isUiComponent: false,
            });
            this.addChild(this.masterGuideComponent);
        } else {
            this.masterGuideComponent.renderGuides();
        }

        if (!this.layoutGuideComponent) {
            this.layoutGuideComponent = new GuideComponent({
                type: ESourceType.layout,
                isUiComponent: false,
            });
            this.addChild(this.layoutGuideComponent);
        } else {
            this.layoutGuideComponent.renderGuides();
        }
    };

    private getAppService = () => AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
}
